import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { getUserInfo } from '#pplx/frontend/user-info/userInfoQueries.js';
import { useMemo } from 'react';
export const USER_INFO_QUERY_KEY = ['user-info'];
const DEFAULT_USER_INFO = {
    isEnterprise: false,
    isGov: false,
    isStudent: false,
    studentCountry: null,
    hasNonPublicEmail: false,
};
export const useUserInfo = ({ enabled, reason, }) => {
    const query = useQuery({
        enabled: enabled ?? true,
        queryKey: USER_INFO_QUERY_KEY,
        queryFn: async () => getUserInfo({ reason }),
        placeholderData: DEFAULT_USER_INFO,
    });
    const data = query.data ?? DEFAULT_USER_INFO;
    return useMemo(() => ({
        query,
        ...data,
    }), [query, data]);
};
//# sourceMappingURL=useUserInfo.js.map